import repositoryFactory from '@/helpers/api/apiFactory';  
const api = repositoryFactory('auth'); 

import cookieHelper from '@/helpers/cookie/cookie'; 
const cookieBridge = new cookieHelper;

const state = { 
    navbar: false,
    logged: !isLogged(),
    tokens: null,
    form: {},
    rules: { 
        email: [
            {  required: true, message: 'Please input email', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: ['blur'] }
        ],
        password: [
            {  required: true, message: 'Please input password', trigger: 'blur' },
            {  min: 6, message: 'Min length 6'}
        ]
    }
};

const mutations = {
    loginUser: (state, value) => state.logged = value,
    setState: (state, {key, value}) => {
        state[key] = value;
    }
};

const actions = {
    async login({state}) {
       return await api.login(state.form); 
    },
    async test() {
        await api.test();
    }
};

const getters = {
    logged: state => state.logged,
    form: state => state.form,
    rules: state => state.rules,
    navbar: state => state.navbar
};

function isLogged() {  
    return (
        (cookieBridge.getCookie('access_token') == undefined || cookieBridge.getCookie('access_token') == 'undefined' ) &&
        (cookieBridge.getCookie('refresh_token') == undefined || cookieBridge.getCookie('refresh_token') == 'undefined' )  
    );
}

export default {
    namespaced: true,
    state, 
    mutations,
    actions,
    getters
}; 